module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAALJJREFUOI3V0zuqAjEUBuDP0Q3YuYArijuwtHIvXjtXYWfno/OxCxckgihoY6eFGRjEBxkF9cCBkJAvPyHh26uYc1+CLnbYvhoiwRQnrFB/FaxhH8AU/cueFpNs4HJNbRzCfAWt2FQJZiHRGg00Q9IJCnmxtFO0mgebX2Fp92OgZ9g4T7LFHWz0Uaz4ABt+FIPeO7DsTynfWB+iE+Bo8Bb2H4NBKTNe4hjGG5e3FoX9Rp0BZgNIRKu9tCUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_edit.png
// module id = grIB
// module chunks = 1